import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const LazyImageTemplate = (props) => {
    const { alt, height, src, width } = props;

    return (
        <LazyLoadImage
            alt={alt || ""}
            effect="blur"
            height={height || "100%"}
            src={src}
            width={width || "100%"}
            {...props}
        />
    );
};

export default LazyImageTemplate;
